import { render, staticRenderFns } from "./AuthorisedIcon.vue?vue&type=template&id=49f292e8&scoped=true"
import script from "./AuthorisedIcon.vue?vue&type=script&lang=js"
export * from "./AuthorisedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f292e8",
  null
  
)

export default component.exports